// Comentarios del «Análisis del bot» en la repetición: el bot habla en primera persona,
// en broma y con frases cortas. Solo usa lo que ya trae el análisis de cada jugada
// (jugada hecha, la que yo habría hecho, la clase y quién la hizo) y quién ganó.
//
// Huecos de las frases:
//   {jugada}  jugada hecha en participio: «incorporado en C11» / «movido el bloque de E13 a C11»
//   {mejor}   mi jugada en infinitivo:     «incorporar en D3» / «mover el bloque de E13 a C11»
//   {mejorP}  mi jugada en participio:     «incorporado en D3»
// Las frases que usan {mejor}/{mejorP} se saltan cuando el análisis no trae mi jugada.

const BANKS = {
  // a) La persona hizo justo lo que yo habría hecho.
  same: [
    "¡Wow, me encanta! Yo habría hecho exactamente lo mismo.",
    "Vaya, piensas como yo… eso me preocupa.",
    "¡Esa es la mía! ¿Me estás copiando?",
    "Idéntica a la que yo tenía pensada. Nada que decir.",
    "Has {jugada}. Justo lo que yo habría hecho, qué miedo.",
    "Perfecto. Si sigues así me dejas sin trabajo.",
    "Misma jugada que la mía. Empiezo a sospechar.",
    "Ni yo lo habría hecho mejor. Literalmente.",
  ],
  sameBrilliant: [
    "¡Brillante! Y encima es justo lo que yo habría hecho.",
    "¡Jugadón! Igual que la mía, pero tú la encontraste solo.",
    "Brillante. Has {jugada} y yo aplaudo… con las dos manos que no tengo.",
    "¡Qué nivel! Esa era la jugada, sin discusión.",
    "Brillante y exacta. Me quito el sombrero.",
    "Esto ya es de maestro. Yo habría hecho lo mismo.",
  ],
  // b) Buena o excelente, pero distinta a la mía.
  good: [
    "Buena jugada… pero no mejor que la mía: yo habría {mejorP}.",
    "Nada mal. Aunque yo habría {mejorP}, por si te interesa.",
    "Bien jugado. Mi idea era {mejor}, pero la tuya también vale.",
    "Muy bien. Casi tan buena como la mía: {mejor}.",
    "Me gusta. No es la mía, pero me gusta.",
    "Correcta. Yo habría {mejorP}… pero no me voy a quejar.",
    "Buena. Tienes ojo, aunque yo tenía otra en mente: {mejor}.",
    "Sólida. Sigues en la pelea.",
  ],
  brilliant: [
    "Brillante, no me lo esperaba. Te felicito.",
    "¡Toma ya! Esa ni la vi venir.",
    "Brillante. Yo habría {mejorP}, pero lo tuyo tiene más arte.",
    "¡Qué jugada! Me has dejado pensando.",
    "Brillante. Voy a fingir que también la había visto.",
    "Jugadón. Ahí me ganaste en imaginación.",
  ],
  // c) Dudosa.
  doubtful: [
    "Mmm, lo dudo… no me lo creo. Pienso que había algo mejor: {mejor}.",
    "¿Seguro? Yo habría {mejorP}.",
    "Interesante… por no decir otra cosa. Yo me quedaba con {mejor}.",
    "Mmm. No me convence. ¿Y si probaras {mejor}?",
    "Arriesgada. Me gusta el valor, no tanto la jugada.",
    "Hmm, curiosa. Yo habría {mejorP} sin pensarlo.",
    "No está mal, pero tampoco bien. Había algo mejor.",
  ],
  // d) Imprecisión / error de la persona.
  inaccuracy: [
    "Has {jugada}, pero era mejor {mejor}. Esto te puede costar.",
    "Imprecisión. Yo habría {mejorP}.",
    "Uy, ahí se te escapó algo. Mejor era {mejor}.",
    "Casi… pero no. Yo habría {mejorP}.",
    "Un pelín impreciso. Tomo nota para usarlo en tu contra.",
    "No es grave, pero {mejor} era más fino.",
    "Has {jugada}. Yo habría {mejorP}, solo digo.",
  ],
  error: [
    "Has {jugada}, pero era mejor {mejor}. Esto te puede costar.",
    "Error. Yo habría {mejorP}, y no lo digo por presumir… bueno, un poco sí.",
    "¡Ay! Aquí tocaba {mejor}.",
    "Mala idea. La buena era {mejor}.",
    "Error a la vista. Lo apunto en mi libreta.",
    "Uff, no. Yo habría {mejorP}.",
    "Esto me da ventaja. Gracias, supongo.",
  ],
  blunder: [
    "¡Uff! Has cometido un error. Esto te va a costar caro.",
    "¡Error grave! Yo habría {mejorP}, sin dudarlo.",
    "¡Ay, ay, ay! Aquí tocaba {mejor}.",
    "Eso no se hace… La jugada era {mejor}.",
    "¡Uy! Esta duele. Mejor era {mejor}.",
    "Error grave. Hasta yo me asusté.",
    "¡Regalo! Gracias, aunque no era mi cumpleaños.",
  ],
  // Persona que PERDIÓ la partida: recordar que eso pudo costar la derrota.
  errorLost: [
    "Has {jugada}, pero era mejor {mejor}. Eso te pudo costar la partida.",
    "Aquí empezó a torcerse todo. Yo habría {mejorP}.",
    "Esta jugada la vas a recordar… y no para bien. Mejor era {mejor}.",
    "Ojo aquí: {mejor} te habría dado otra partida.",
    "Error que se paga. Y se pagó.",
    "Aquí se escapó la partida. Yo habría {mejorP}.",
    "Este es el momento que yo revisaría dos veces.",
  ],
  blunderLost: [
    "¡Uff! Error grave, y eso te pudo costar la partida.",
    "Aquí se fue todo. Yo habría {mejorP}.",
    "¡Ay! Con {mejor} la historia habría sido otra.",
    "Error grave. Si buscas dónde perdiste, es aquí.",
    "Esta te costó caro, muy caro.",
    "Aquí empezó a torcerse todo. Y bien torcido.",
  ],
  // Persona que GANÓ la partida: más suave.
  errorWonBot: [
    "Te salió bien al final, pero aquí me diste una oportunidad.",
    "Ganaste, sí, pero aquí yo habría {mejorP}.",
    "Aquí me dejaste una puerta abierta… y no la vi. Mejor era {mejor}.",
    "Pequeño despiste. Por suerte para ti, yo también me despisté.",
    "Al final ganaste, pero esto no lo enseñes en clase.",
    "Aquí tuve mi oportunidad. Lo dejo pasar… por esta vez.",
  ],
  errorWon: [
    "Te salió bien al final, pero aquí diste una oportunidad.",
    "Ganaste, sí, pero aquí yo habría {mejorP}.",
    "Al final no pasó nada, pero {mejor} era más seguro.",
    "Pequeño despiste. Por suerte, no te lo cobraron.",
    "Al final ganaste, pero esto no lo enseñes en clase.",
    "Bien salvado al final. Aquí tocaba {mejor}.",
  ],
  // Libro (primeras jugadas).
  book: [
    "Apertura de manual. Nada que objetar.",
    "Jugada de libro. Calentando motores.",
    "Empezamos tranquilos. Todo en orden.",
    "Clásico. Así empiezo yo también.",
    "Primeros pasos, sin sorpresas.",
    "De libro. Ahora empieza lo bueno.",
  ],
  // e) Mi propia imprecisión o error.
  botBad: [
    "Uff, he cometido una imprecisión. Tomo nota, para la próxima lo haré mejor.",
    "Error mío… todavía me falta entrenamiento, pero voy mejorando.",
    "Vale, aquí debí {mejor}. Nadie es perfecto, ni yo.",
    "Esta no me salió. Hagamos como que no la viste.",
    "Ups. Yo también me equivoco, no se lo cuentes a nadie.",
    "He {jugada}, cuando lo bueno era {mejor}. Lo apunto.",
    "Fallo mío. Me pongo a entrenar ahora mismo.",
  ],
  botBadLost: [
    "Error mío… y aquí empecé a perder. Todavía me falta entrenamiento.",
    "Uff, imprecisión mía. Tú la aprovechaste, te felicito.",
    "Aquí debí {mejor}. Lección aprendida.",
    "Fallo mío. Estoy mejorando para la próxima.",
    "Esta me la apunto: no se repite.",
    "Me equivoqué y tú no perdonaste. Bien jugado.",
  ],
  // f) Mi jugada buena.
  botGood: [
    "Esta me salió preciosa, lo admito.",
    "Jugada de campeón. No es por presumir… bueno, sí.",
    "He {jugada}. Elegante, ¿verdad?",
    "Precisa como un reloj. Así me gusta.",
    "Ni yo mismo me esperaba algo tan bueno.",
    "Toma nota, que esto es nivel profesional.",
    "Bonita, ¿eh? Me la enmarco.",
    "Así se juega. Te lo dejo de ejemplo.",
  ],
  botGoodLost: [
    "Por lo menos esta me salió bien.",
    "Buena jugada mía… aunque al final no bastó.",
    "Esta sí. Lástima que no fueran todas así.",
    "Aquí estuve bien. Sigo aprendiendo.",
    "Una buena, para no perder la dignidad.",
    "Me gustó esta. Estoy mejorando para la próxima.",
  ],
  botDoubtful: [
    "Esta no me convence ni a mí. Mejor era {mejor}.",
    "Mmm, mía y dudosa. Pasa en las mejores familias.",
    "Me arriesgué un poco. Quizá {mejor} era más sensato.",
    "Jugada rara, lo sé. Tenía un plan… creo.",
    "No es mi mejor momento. Seguimos.",
  ],
  botBook: [
    "Empiezo de libro, como siempre.",
    "Apertura de manual. Calentando.",
    "Primeros pasos tranquilos.",
    "Jugada de libro, sin sorpresas.",
    "Empiezo con calma, lo bueno viene después.",
  ],
  // g) Si yo perdí la partida: más humilde con las jugadas buenas de la persona.
  goodBeatBot: [
    "Hiciste una excelente jugada, no me lo esperaba.",
    "Te felicito, muy bien jugado.",
    "Buena jugada. Por eso me ganaste.",
    "Muy bien. Todavía me falta entrenamiento.",
    "Bien visto. Estoy mejorando para la próxima.",
    "Buena. Yo habría {mejorP}, pero tú ganaste, así que tú sabrás.",
  ],
  brilliantBeatBot: [
    "Te felicito, brillante jugada.",
    "Brillante. Con jugadas así es normal que me ganaras.",
    "¡Qué jugada! No me lo esperaba.",
    "Brillante. Me la guardo para aprender.",
    "Jugadón. Me quito el sombrero.",
  ],
  sameBeatBot: [
    "Igual que lo que yo habría hecho. Con razón me ganaste.",
    "Misma jugada que la mía. Juegas muy bien.",
    "Exacto. Tú y yo pensamos igual… pero tú ganaste.",
    "Perfecta. Estoy mejorando para alcanzarte.",
    "Lo mismo que yo. Te felicito.",
  ],
};

const HUMAN_GOOD_KINDS = new Set(["excelente", "buena"]);
const BAD_KINDS = new Set(["imprecision", "error", "grave"]);

const cellText = (cell) => String(cell || "").trim().toUpperCase();

// Una entrada al tablero (notación -m1 / =m1, o origen igual al destino como «M1M1») se dice
// «incorporar en M1»; un movimiento normal, «mover el bloque de E13 a C11».
export const isReplayReviewEntry = (described) => {
  if (!described) return false;
  if (described.kind === "place") return true;
  const notation = String(described.notation || "").trim();
  if (/^[-=]/.test(notation)) return true;
  const from = cellText(described.from);
  return !from || from === cellText(described.to);
};

export const describeReplayReviewMove = (described, form = "infinitive") => {
  if (!described || !cellText(described.to)) return "";
  const to = cellText(described.to);
  if (isReplayReviewEntry(described)) {
    const what = described.special ? "el especial " : "";
    return `${form === "participle" ? "incorporado" : "incorporar"} ${what}en ${to}`;
  }
  return `${form === "participle" ? "movido" : "mover"} el bloque de ${cellText(described.from)} a ${to}`;
};

const usesBest = (phrase) => phrase.includes("{mejor");

const fill = (phrase, values) =>
  phrase
    .replace(/\{jugada\}/g, values.jugada)
    .replace(/\{mejorP\}/g, values.mejorP)
    .replace(/\{mejor\}/g, values.mejor)
    .replace(/\s+/g, " ")
    .trim();

const hashSeed = (seed) => {
  const text = String(seed || "");
  let hash = 7;
  for (let i = 0; i < text.length; i += 1) hash = (hash * 31 + text.charCodeAt(i)) >>> 0;
  return hash;
};

// Qué grupo de frases toca a esta jugada. «count» es cuántas jugadas del mismo tipo
// van antes (para alternar con los tonos de derrota/victoria de forma estable).
const pickBank = ({ move, meta }) => {
  const players = Array.isArray(meta?.players) ? meta.players : [];
  const mover = Number(move?.playerIndex);
  const moverIsBot = Boolean(players[mover]?.isBot);
  const hasBot = players.some((player) => player?.isBot);
  const winnerIndex = Number.isFinite(Number(meta?.winnerIndex)) ? Number(meta.winnerIndex) : -1;
  const finished = winnerIndex >= 0;
  const botLost = hasBot && finished && !players[winnerIndex]?.isBot;
  const moverLost = finished && winnerIndex !== mover;
  const moverWon = finished && winnerIndex === mover;
  const kind = String(move?.kind || "");
  const same = Boolean(move?.bestIsPlayed) || kind === "mejor";

  if (moverIsBot) {
    if (kind === "libro") return { bank: "botBook" };
    if (BAD_KINDS.has(kind)) return { bank: botLost ? "botBadLost" : "botBad" };
    if (kind === "interesante") return { bank: "botDoubtful" };
    return { bank: botLost ? "botGoodLost" : "botGood" };
  }

  if (kind === "libro") return { bank: "book" };
  if (BAD_KINDS.has(kind)) {
    const base = kind === "grave" ? "blunder" : kind === "error" ? "error" : "inaccuracy";
    if (moverLost) return { bank: kind === "grave" ? "blunderLost" : "errorLost", alt: base, often: true };
    if (moverWon) return { bank: hasBot ? "errorWonBot" : "errorWon", alt: base };
    return { bank: base };
  }
  if (kind === "interesante") return { bank: "doubtful" };
  if (same) {
    if (botLost) return { bank: "sameBeatBot" };
    return { bank: kind === "brillante" ? "sameBrilliant" : "same" };
  }
  if (kind === "brillante") return { bank: botLost ? "brilliantBeatBot" : "brilliant" };
  if (HUMAN_GOOD_KINDS.has(kind) || kind) return { bank: botLost ? "goodBeatBot" : "good" };
  return { bank: "good" };
};

// Devuelve { [step]: texto } para todas las jugadas analizadas. Se calcula de una vez sobre
// toda la partida: así la frase de cada jugada es siempre la misma (también al volver atrás)
// y dos jugadas seguidas del mismo tipo no repiten frase.
export const buildReplayReviewComments = (moves, meta, seed = "") => {
  const list = Array.isArray(moves) ? moves : [];
  const counters = {};
  const offsets = {};
  const lastByBank = {};
  const base = hashSeed(seed);
  const comments = {};
  const sorted = list.slice().sort((a, b) => Number(a?.step) - Number(b?.step));
  sorted.forEach((move) => {
    if (!move) return;
    const choice = pickBank({ move, meta });
    let bankName = choice.bank;
    if (choice.alt) {
      // Con derrota, 2 de cada 3 recuerdan que eso pudo costar la partida; con victoria, 1 de cada 2.
      const key = `${choice.bank}|turn`;
      const turn = counters[key] || 0;
      counters[key] = turn + 1;
      const useMain = choice.often ? turn % 3 !== 2 : turn % 2 === 0;
      if (!useMain) bankName = choice.alt;
    }
    const hasBest = Boolean(move.best && cellText(move.best.to));
    const values = {
      jugada: describeReplayReviewMove(move.played, "participle") || "jugado",
      mejor: describeReplayReviewMove(move.best, "infinitive"),
      mejorP: describeReplayReviewMove(move.best, "participle"),
    };
    let bank = BANKS[bankName] || BANKS.good;
    bank = bank.filter((phrase) => (hasBest || !usesBest(phrase)) && (move.played || !phrase.includes("{jugada}")));
    if (!bank.length) bank = ["Seguimos."];
    if (offsets[bankName] === undefined) offsets[bankName] = (base + bankName.length * 13) % bank.length;
    const count = counters[bankName] || 0;
    counters[bankName] = count + 1;
    let phrase = bank[(offsets[bankName] + count) % bank.length];
    if (phrase === lastByBank.__last && bank.length > 1) {
      counters[bankName] += 1;
      phrase = bank[(offsets[bankName] + count + 1) % bank.length];
    }
    lastByBank.__last = phrase;
    comments[Number(move.step)] = fill(phrase, values);
  });
  return comments;
};

export const REPLAY_REVIEW_COMMENT_BANKS = BANKS;

// Modo Entrenador (durante la partida): tono serio y didáctico, recomendaciones claras, sin bromas.
const TRAINER_BANKS = {
  same: [
    "¡Muy bien! Es justo la jugada que te recomendaría.",
    "Correcto: es la mejor jugada en esta posición.",
    "Excelente elección. No había nada mejor.",
    "Muy bien jugado. Sigue así.",
    "Exacto, esa es la jugada más precisa.",
  ],
  brilliant: [
    "¡Brillante! Una jugada de gran nivel.",
    "¡Brillante! Has encontrado una jugada muy difícil de ver.",
    "Jugada brillante. Muy bien calculado.",
  ],
  good: [
    "Buena jugada. Otra opción aún mejor era {mejor}.",
    "Bien jugado. También podías {mejor}, que era un poco más precisa.",
    "Jugada correcta. Te recomiendo fijarte también en {mejor}.",
    "Buena decisión. La jugada más precisa era {mejor}.",
    "Bien. Para afinar más: {mejor} era todavía mejor.",
  ],
  book: [
    "Jugada de apertura correcta.",
    "Buen inicio: es una jugada habitual de apertura.",
    "Apertura correcta. Desarrolla tus bloques con calma.",
  ],
  doubtful: [
    "Jugada dudosa. Te recomiendo {mejor}; mantiene mejor tu posición.",
    "Esta jugada no es la más segura. Era mejor {mejor}.",
    "Jugada discutible. Considera {mejor} en posiciones como esta.",
    "Hay algo mejor aquí: {mejor}.",
  ],
  inaccuracy: [
    "Has cometido una imprecisión. Era mejor {mejor}.",
    "Esto es una imprecisión. Para la próxima te recomiendo {mejor}; eso habría sido una jugada excelente.",
    "Imprecisión. La jugada recomendada era {mejor}.",
    "Pequeña imprecisión. Con {mejor} tu posición quedaba mejor.",
  ],
  error: [
    "Esto es un error. Lo correcto era {mejor}.",
    "Error: esta jugada te quita ventaja. Te recomiendo {mejor}.",
    "Has cometido un error. La mejor opción era {mejor}.",
    "Error. Revisa la posición: {mejor} era mucho mejor.",
  ],
  blunder: [
    "Error grave: esta jugada te deja en clara desventaja. Lo correcto era {mejor}.",
    "Error grave. La jugada recomendada era {mejor}.",
    "Cuidado: es un error grave. Con {mejor} mantenías la partida.",
    "Error grave. Antes de mover, revisa qué puede hacer tu rival. Lo mejor era {mejor}.",
  ],
};

export const REPLAY_TRAINER_COMMENT_BANKS = TRAINER_BANKS;

// Si el servidor no trae la jugada recomendada.
const TRAINER_FALLBACK = {
  good: "Buena jugada.",
  doubtful: "Jugada dudosa. Revisa si había algo mejor.",
  inaccuracy: "Has cometido una imprecisión.",
  error: "Esto es un error.",
  blunder: "Error grave: esta jugada te deja en desventaja.",
};

// feedback = { kind, best, isBest, played, step } tal como llega de /trainer/classify.
export const buildTrainerComment = (feedback) => {
  if (!feedback || !feedback.kind) return "";
  const kind = String(feedback.kind);
  const hasBest = Boolean(!feedback.isBest && feedback.best && cellText(feedback.best.to));
  let bankName = "good";
  if (kind === "libro") bankName = "book";
  else if (kind === "grave") bankName = "blunder";
  else if (kind === "error") bankName = "error";
  else if (kind === "imprecision") bankName = "inaccuracy";
  else if (kind === "interesante") bankName = "doubtful";
  else if (feedback.isBest || kind === "mejor") bankName = kind === "brillante" ? "brilliant" : "same";
  else if (kind === "brillante") bankName = "brilliant";
  let bank = TRAINER_BANKS[bankName].filter((phrase) => hasBest || !usesBest(phrase));
  if (!bank.length) bank = [TRAINER_FALLBACK[bankName] || "Jugada registrada."];
  const index = Math.abs(Math.floor(Number(feedback.step) || 0)) % bank.length;
  return fill(bank[index], {
    jugada: describeReplayReviewMove(feedback.played, "participle"),
    mejor: describeReplayReviewMove(feedback.best, "infinitive"),
    mejorP: describeReplayReviewMove(feedback.best, "participle"),
  });
};
